import React from 'react';
import cn from 'classnames';

import { pluralizePortions } from 'app/utils/pluralize';

import { DishPicture } from '../DishPicture';
import { DishTitle } from '../DishTitile';
import { DishDescription } from '../DishDescription';

import { useButtonOptimisticState } from '../useButtonOptimisticState';
import { AddToBasketButtonUI } from '../AddToBasketButtonUI';

import { roundPrice } from '../roundPrice';

import styles from './dish-layout-secondary.scss';


export function DishLayoutSecondary(props) {
    const {
        colors,
        index,
        imageUrl,
        imageUrlDesktop,
        joinDishTitlesinMobile,
        buttonsDisabled,
        id,
        dishCountStep,
        price,
        originalPrice,
        portion,

        title,
        description,
        partnersComment,
        trackAddToBasket,
    } = props;

    const { isDishInBasket, handleAddToBasket } = useButtonOptimisticState(
        id,
        portion,
        dishCountStep,
        trackAddToBasket,
    );

    const priceWithPortions = roundPrice(price * dishCountStep);
    const originalPriceWithPortions = roundPrice(originalPrice * dishCountStep);

    const hasDiscount = price !== originalPrice;

    const buttonContainerClasses = cn({
        [styles['dish-layout-secondary__content-button']]: true,
        [styles['dish-layout-secondary__content-button--wide']]: hasDiscount,
    });

    return (
        <div className={styles['dish-layout-secondary']}>
            <div className={styles['dish-layout-secondary__img']}>
                <DishPicture
                    alt={title[0]}
                    useLazyLoading={index === 0}
                    imageUrl={imageUrl}
                    imageUrlDesktop={imageUrlDesktop}
                />
            </div>
            <div className={styles['dish-layout-secondary__content']}>
                <div className={styles['dish-layout-secondary__content-text']}>
                    <DishTitle
                        joinDishTitlesinMobile={joinDishTitlesinMobile}
                        title={title}
                        colors={colors}
                        layout="secondary"
                    />
                    <DishDescription
                        areDetailsEnabled={false}
                        description={description}
                        partnersComment={partnersComment}
                        layout="secondary"
                    />
                </div>
                <div className={buttonContainerClasses}>
                    <AddToBasketButtonUI
                        handleAddToBasket={handleAddToBasket}
                        isDishInBasket={isDishInBasket}
                        buttonsDisabled={buttonsDisabled}
                        hasDiscount={hasDiscount}
                        price={priceWithPortions}
                        originalPrice={originalPriceWithPortions}
                    />
                    <div className={styles['dish-layout-secondary__portions']}>
                        <div className="tom-main-banner-content-dish-row-one__button-about">
                            {dishCountStep}
                            -
                            {dishCountStep + 1}
                            &nbsp;
                            {pluralizePortions(dishCountStep + 1)}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
